const messages = {
  widgetHeader: 'Products Summary',
  totalUnits: 'Total Units',
  products: 'Products',
  colors: 'Colors',
  wholesale: 'Wholesale:',
  suggRetail: 'Sugg. Retail:',
  totalQty: 'Total Qty',
  totalCost: 'Total Cost',
  totalStyleQty: 'Total Style Qty',
  totalStyleCost: 'Total Style Cost',
  styleDiscount: 'Style Discount',
  finalStyleCost: 'Final Style Cost',
  error: {
    title: 'Error loading products',
    message: 'There was an error loading your products.',
    reload: 'Reload',
    tryAgain: 'now or try again later.',
  },
  empty: {
    title: 'No products',
    messageStart: 'This order has no products in it.',
    addProducts: 'Add products',
    messageEnd: 'to see them here.',
  },
  productsLoader: {
    info: ({
      count,
      total,
    }: {
      count: number | string
      total: number | string
    }) => `Showing products 1-${count} of ${total}`,
    loadAll: 'Load All Products',
    loadMore: 'Load More Products',
    loadingAll: 'Loading All Products',
    loadingMore: 'Loading More Products',
    error: 'Error loading remaining products. Try again.',
  },
  styleComments: 'Style Comments:',
  colorComments: 'Color Comments:',
  casepackQty: 'C/pack Qty',
  bulk: 'Bulk',
  unavailableSkusWarning:
    'Updates to styles in this order have caused quantity and cost information to be out of date. Hit edit to see the styles that have been affected.',
  priceTypeError:
    'An update to the price type associated with this order has caused cost information to be out of date. Reach out to the brand directly if you believe this is a mistake.',
  linesheetNoVisibleWarning:
    'The linesheet associated with some or all of the products below is no longer visible. Reach out to the brand directly if you believe this is a mistake.',
  attributes: 'Attributes:',
  countryOfOrigin: 'Country of Origin:',
} as const

export default messages
